export interface AWSConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
}

export const awsConfig: AWSConfig = {
  region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
  userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID || '',
  userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID || '',
};

export const apiBaseUrl: string = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000';

export const appVersion: string = import.meta.env.VITE_APP_VERSION || 'v.0.0.0';
